module.exports = __webpack_public_path__ + "assets/img/37_1486.2d4251c8.jpg";